/* star_open.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" xml:space="preserve">
            <path class="foreground-gl" d="M4.27,19.87a.72.72,0,0,1-.7-.89l1.52-6.4L.25,8.34A.72.72,0,0,1,.67,7.08L6.95,6.6,9.33.52a.75.75,0,0,1,1.34,0L13,6.6l6.28.47a.72.72,0,0,1,.42,1.26l-4.83,4.24L16.43,19a.72.72,0,0,1-1.09.77L10,16.29,4.66,19.75A.72.72,0,0,1,4.27,19.87ZM10,14.71a.72.72,0,0,1,.39.12l4.22,2.73-1.2-5.07a.72.72,0,0,1,.23-.71l3.87-3.4-5-.38a.72.72,0,0,1-.62-.46L10,2.76,8.13,7.55A.72.72,0,0,1,7.51,8l-5,.38,3.87,3.4a.72.72,0,0,1,.23.71l-1.2,5.07L9.6,14.83A.72.72,0,0,1,10,14.71Z" transform="translate(-0.01 -0.1)"/>
        </svg>
    `
};
